import { AppLanguage, validateLanguageCode } from '@skippay/core/i18n/languages';

import { getMessages } from './index';

export function getAppLanguage(): {
	locale: AppLanguage;
	messages: Record<string, string>;
} {
	if (process.env.LANGUAGE && validateLanguageCode(process.env.LANGUAGE)) {
		return {
			locale: process.env.LANGUAGE,
			messages: getMessages(process.env.LANGUAGE),
		};
	}

	return {
		locale: AppLanguage.cs,
		messages: getMessages(AppLanguage.cs),
	};
}
